const md = require('markdown-it')();
const dedent = require('dedent-js');
var mila = require('markdown-it-link-attributes');

md.use(mila, {
  attrs: {
    target: '_blank',
    rel: 'noopener',
  },
});

// coursesValue:
// RNCP5 for e-learning
// RNCP6 for temps plein, alternance
// RNCP5-landing or RNCP6-landing to display on landing pages

const QA = [
  {
    question: 'Quels langages de programmation vais-je apprendre ?',
    answer: md.render(
      dedent`Vous apprendrez principalement les langages, bibliothèques, frameworks et outils suivants : GitHub, JavaScript, HTML5, CSS, Node.js, Express, MongoDB, Atlas, Northflank, React.js, React Native. Il pourra aussi vous être proposé différents ateliers : Devenir développeur freelance, Scrapping de données, Travailler avec agilité (SCRUM), Réussir son entretien d’embauche, Utiliser Retool, etc. Nous nous adaptons au niveau et aux demandes des participants. Pour savoir ce que vous allez savoir faire en fin de formation, [cliquez ici](/bootcamp-javascript/concepteur-developpeur-applications-temps-plein#objectives).`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Quels langages de programmation vais-je apprendre ?',
    answer: md.render(
      dedent`Vous apprendrez principalement les langages, bibliothèques, frameworks et outils suivants : GitHub, JavaScript, HTML5, CSS, Node.js, Express, MongoDB, Atlas, Northflank, React.js, React Native. Il pourra aussi vous être proposé différents ateliers : Devenir développeur freelance, Scrapping de données, Travailler avec agilité (SCRUM), Réussir son entretien d’embauche, Utiliser Retool, etc. Nous nous adaptons au niveau et aux demandes des participants et de l'entreprise d'accueil.`
    ),
    courses: ['RNCP6-landing'],
  },
  {
    question: 'Quels langages de programmation vais-je apprendre ?',
    answer: md.render(
      dedent`Vous apprendrez principalement les langages, bibliothèques, frameworks et outils suivants : GitHub, JavaScript, HTML5, CSS, Node.js, Express, MongoDB, Atlas, Northflank, React.js, Vue.js, React Native, TypeScript, Backend avancé (tests unitaires, sécurisation d'un serveur, SWR, Prisma, Strapi, SQLite, PostgreSQL, etc.), React avancé (Redux, Next.js, React Testing Library, Tailwind, etc.).`
    ),
    courses: ['RNCP6-landing-alternance'],
  },
  {
    question: 'Quels langages de programmation vais-je apprendre ?',
    answer: md.render(
      dedent`Vous apprendrez principalement les langages, bibliothèques, frameworks et outils suivants : GitHub, JavaScript, HTML5, CSS, Vue.js., Strapi, SQLite, PostgreSQL, Northflank. Pour savoir ce que vous allez savoir faire en fin de formation, [cliquez ici](/cours-informatique/formation-developpeur-web-et-web-mobile/#objectives).`
    ),
    courses: ['RNCP5'],
  },
  {
    question: 'Quels langages de programmation vais-je apprendre ?',
    answer: md.render(
      dedent`Vous apprendrez principalement les langages, bibliothèques, frameworks et outils suivants : GitHub, JavaScript, HTML5, CSS, Vue.js, Strapi, SQLite, PostgreSQL, Northflank.`
    ),
    courses: ['RNCP5-landing'],
  },
  {
    question: 'Comment se déroule une journée-type ?',
    answer: md.render(
      dedent`Concernant le [bootcamp à plein temps](/bootcamp-javascript/concepteur-developpeur-applications-temps-plein), la [journée-type](/bootcamp-javascript/concepteur-developpeur-applications-temps-plein#typical-day) commence à 9h et finit à 18h, tous les jours, sauf le week-end. Chaque jour est très intensif et vous devez être préparé à travailler dur. En début de matinée, vous aurez la correction live des exercices de la veille, puis un cours théorique de 1h30 à 2h vous sera donné. Enfin, tout le reste de la journée, vous réaliserez des exercices en lien avec les sujets abordés le matin. `
    ),
    courses: ['RNCP6'],
  },
  {
    question:
      'À la sortie de la formation, serai-je capable de créer un site ou une application Mobile tout seul ?',
    answer: md.render(
      dedent`Oui. Notre formation a vocation à faire de vous un Développeur entièrement autonome. Vous serez donc en mesure de créer les sites Web et applications Mobile de votre choix, à l'issue du bootcamp. Vous avez un projet d'application ? Passez à la pratique, nous saurons vous encadrer comme il se doit ! [Cliquez ici](/bootcamp-javascript/concepteur-developpeur-applications-temps-plein#objectives) pour avoir un récapitulatif complet de tout ce que vous allez apprendre.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Quel ordinateur dois-je posséder ?',
    answer: md.render(
      dedent`Nous recommandons à nos élèves de posséder un Mac récent (postérieur à 2020) avec au moins 8Go de RAM (16Go, c'est encore mieux) et 256Go de disque dur SSD. En effet, lors des cours de développement Mobile, vous aurez absolument besoin d'exécuter le logiciel Xcode (développé par Apple et uniquement exécutable sur un Mac) pour créer des applications pour iPhone/iPad. Sinon, vous ne pourrez développer que pour les téléphones Android. Développer avec un ordinateur sous Windows est une source inépuisable d'ennuis, sachez-le. Si vous souhaitez acheter un Mac, nous vous conseillons de vous tourner vers les [produits reconditionnés certifiés sur Apple Store](https://www.apple.com/fr/shop/refurbished/mac/macbook-pro) (uniquement).`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Quel ordinateur dois-je posséder ?',
    answer: md.render(
      dedent`Nous recommandons à nos élèves de posséder un Mac récent (postérieur à 2020) avec au moins 8Go de RAM (16Go, c'est encore mieux) et 256Go de disque dur SSD. En effet, lors des cours de développement Mobile, vous aurez absolument besoin d'exécuter le logiciel Xcode (développé par Apple et uniquement exécutable sur un Mac) pour créer des applications pour iPhone/iPad. Sinon, vous ne pourrez développer que pour les téléphones Android. Développer avec un ordinateur sous Windows est une source inépuisable d'ennuis, sachez-le. Si vous souhaitez acheter un Mac, nous vous conseillons de vous tourner vers les produits reconditionnés certifiés sur Apple Store (uniquement).`
    ),
    courses: ['RNCP6-landing', 'RNCP6-landing-alternance'],
  },
  {
    question: 'Quel ordinateur dois-je posséder ?',
    answer: md.render(
      dedent`Nous recommandons à nos élèves de posséder un Mac récent avec au moins 8Go de RAM et 256Go de disque dur SSD.`
    ),
    courses: ['RNCP5', 'RNCP5-landing'],
  },
  {
    question: "En quoi consiste le test de logique que vous faîtes passer à l'entrée ?",
    answer: md.render(
      dedent`La demande en formation est telle que nous ne pouvons pas accepter tout le monde. Le test de logique que nous faisons passer, avant de pouvoir vous inscrire officiellement, nous permet de situer votre niveau de logique, afin que vous puissiez suivre la formation sans encombre.
      
      Le test de logique est chronométré et doit être réalisé en 1 heure maximum. Il contient 23 questions et il n'est pas nécessaire de connaître la programmation pour répondre aux questions.
      
      Attention cependant, le test ne peut pas être passé sur un téléphone ; vous devez posséder un ordinateur pour y accéder.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: "Comment se préparer au mieux avant d'intégrer le bootcamp ?",
    answer: md.render(
      dedent`Les choses importantes pour rentrer au Reacteur sont la motivation, la curiosité, l'envie d'apprendre et de travailler. Il vous faudra comprendre l'anglais un minimum, aussi (pas de panique, nos cours sont bien tous en français, mais nous pourrons vous conseiller de lire certaines ressources en anglais au cours de votre cursus).
      
      Si vous êtes en reconversion professionnelle, sachez que nous vous dispenserons un enseignement optimisé pour devenir Développeur Web/Mobile, en un temps record. La route sera courte (10 semaines à temps plein), le terrain ardu mais pas infranchissable : tout ne sera qu'une question de volonté.
      
      Nous mettons à votre disposition une [préparation gratuite](/apprendre-a-coder-gratuitement/) au code, que nous vous recommandons de suivre avant de vous lancer dans la formation. D’une durée de 40h, 100% en ligne, elle vous permettra de maîtriser les bases du HTML/CSS et du JavaScript et ainsi de démarrer votre cursus plus serein et préparé.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: "Comment se préparer au mieux avant d'intégrer le bootcamp ?",
    answer: md.render(
      dedent`Les choses importantes pour rentrer au Reacteur sont la motivation, la curiosité, l'envie d'apprendre et de travailler. Il vous faudra comprendre l'anglais un minimum, aussi (pas de panique, nos cours sont bien tous en français, mais nous pourrons vous conseiller de lire certaines ressources en anglais au cours de votre cursus).
      
      Si vous êtes en reconversion professionnelle, sachez que nous vous dispenserons un enseignement optimisé pour devenir Développeur Web/Mobile, en un temps record. La route sera courte (10 semaines à temps plein), le terrain ardu mais pas infranchissable : tout ne sera qu'une question de volonté.
      
      Nous mettons à votre disposition une préparation gratuite au code, que nous vous recommandons de suivre avant de vous lancer dans la formation. D’une durée de 40h, 100% en ligne, elle vous permettra de maîtriser les bases du HTML/CSS et du JavaScript et ainsi de démarrer votre cursus plus serein et préparé.`
    ),
    courses: ['RNCP6-landing', 'RNCP6-landing-alternance'],
  },
  {
    question: "Comment se préparer au mieux avant d'intégrer la formation ?",
    answer: md.render(
      dedent`Les choses importantes pour rentrer au Reacteur sont la motivation, la curiosité, l'envie d'apprendre et de travailler. Il vous faudra comprendre l'anglais un minimum, aussi (pas de panique, nos cours sont bien tous en français, mais nous pourrons vous conseiller de lire certaines ressources en anglais au cours de votre cursus).
            
      Nous mettons à votre disposition une [préparation gratuite](/apprendre-a-coder-gratuitement/) au code, que nous vous recommandons de suivre avant de vous lancer dans la formation. D’une durée de 40h, 100% en ligne, elle vous permettra de maîtriser les bases du HTML/CSS et du JavaScript et ainsi de démarrer votre cursus en e-learning plus serein et préparé.`
    ),
    courses: ['RNCP5'],
  },
  {
    question: "Comment se préparer au mieux avant d'intégrer la formation ?",
    answer: md.render(
      dedent`Les choses importantes pour rentrer au Reacteur sont la motivation, la curiosité, l'envie d'apprendre et de travailler. Il vous faudra comprendre l'anglais un minimum, aussi (pas de panique, nos cours sont bien tous en français, mais nous pourrons vous conseiller de lire certaines ressources en anglais au cours de votre cursus).
            
      Nous mettons à votre disposition une préparation gratuite au code, que nous vous recommandons de suivre avant de vous lancer dans la formation. D’une durée de 40h, 100% en ligne, elle vous permettra de maîtriser les bases du HTML/CSS et du JavaScript et ainsi de démarrer votre cursus en e-learning plus serein et préparé.`
    ),
    courses: ['RNCP5-landing'],
  },
  {
    question: 'Le Reacteur aide-t-il les élèves à trouver du travail ?',
    answer: md.render(
      dedent`Tous les élèves font partie intégrante de la communauté d'alumnis (anciens élèves) du Reacteur. À ce titre, ils ont accès à un espace de discussion privé où sont postées régulièrement des offres d'emploi/stage, etc. Après la formation, nous gardons un lien avec chaque promotion. Les formateurs, comme les anciens élèves, sont là pour aider, échanger, conseiller. Profitez de notre réseau pour être redirigé vers les entreprises qui recrutent.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Votre formation est-elle certifiante ?',
    answer: md.render(
      dedent`Oui, la formation du Reacteur vous permet d'obtenir le titre RNCP de niveau 6 de [Concepteur Développeur d'Applications](https://www.francecompetences.fr/recherche/rncp/37873/). Cette certification est délivrée par le Ministère du Travail et vous donnera une équivalence Bac+3/4.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Votre formation est-elle certifiante ?',
    answer: md.render(
      dedent`Oui, la formation du Reacteur vous permet d'obtenir le titre RNCP de niveau 6 de Concepteur Développeur d'Applications. Cette certification est délivrée par le Ministère du Travail et vous donnera une équivalence Bac+3/4.`
    ),
    courses: ['RNCP6-landing', 'RNCP6-landing-alternance'],
  },
  {
    question: 'Votre formation est-elle certifiante ?',
    answer: md.render(
      dedent`Oui, la formation du Reacteur vous permet d'obtenir le titre RNCP de niveau 5 de [Développeur Web et Web Mobile](https://www.francecompetences.fr/recherche/rncp/37674/) (des frais de passage d’examen de 600 euros sont à prévoir, si vous voulez passer le titre). Cette certification est délivrée par le Ministère du Travail et vous donnera une équivalence Bac+2.`
    ),
    courses: ['RNCP5'],
  },
  {
    question: 'Votre formation est-elle certifiante ?',
    answer: md.render(
      dedent`Oui, la formation du Reacteur vous permet d'obtenir le titre RNCP de niveau 5 de Développeur Web et Web Mobile (des frais de passage d’examen de 600 euros sont à prévoir, si vous voulez passer le titre). Cette certification est délivrée par le Ministère du Travail et vous donnera une équivalence Bac+2.`
    ),
    courses: ['RNCP5-landing'],
  },
  {
    question: 'Vais-je trouver un travail après la formation ?',
    answer: md.render(
      dedent`Si vous suivez la formation en temps plein, vous serez invités, en fin de formation, à créer des projets, de 3 à 5 personnes, afin de se constituer un book. Seuls, ces projets vous permettront de vous faire remarquer auprès des recruteurs. C'est une étape essentielle qui mettra votre autonomie à l'épreuve ; Vous devrez être assidus pendant ces semaines. Toute l'équipe du Reacteur est bien évidemment là pour vous soutenir pendant cette période de projets. Notre objectif est de vous donner tous les moyens pour décrocher un emploi, un contrat. Les meilleurs auront le privilège d'être placés dans des entreprises de notre réseau, pour celles et ceux qui le souhaitent.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Pourquoi choisir Le Reacteur ?',
    answer: md.render(
      dedent`Nous formons environ 250 personnes chaque année. Nous sommes spécialisés sur le JavaScript et sommes les premiers à avoir proposé une formation Full-Stack Web et Mobile, en Europe, dès 2016. Nous sommes également le premier centre de formation à avoir enseigné React Native. **Farid Safi**, notre CTO est l'un des développeurs JavaScript le plus renommé de France. Il a énormément contribué au monde de l’open-source en aidant des milliers de développeurs du monde entier. Notre expertise dans le domaine et notre pédagogie nous a permis de gagner la reconnaissance et la confiance de grands groupes et autres célèbres PME/Startups. Les élèves qui sont passés par Le Reacteur travaillent en tant que freelances, entrepreneurs ou sont employés en CDI au sein d'une entreprise.`
    ),
    courses: ['RNCP5', 'RNCP6', 'RNCP6-landing', 'RNCP5-landing', 'RNCP6-landing-alternance'],
  },
  // {
  //   question: 'Pour quelles entreprises Le Reacteur a-t-il travaillé ?',
  //   answer: md.render(
  //     dedent`Nous avons apporté notre expertise à ces entreprises : Canal+, leboncoin, Sopra Steria, Technicolor, Rakuten, Simplon, Skello, SnapShift, Openclassrooms, NouvelObs, Engie, Axway, EuroPages, Devoteam, BNP, Carrefour, etc...`
  //   ),
  //   courses: ['E-Learning', 'Temps Plein', 'Temps Partiel', 'Alternance'],
  // },
  {
    question: `Je suis inscrit à France Travail, puis-je bénéficier d'un financement ?`,
    answer: md.render(
      dedent`Oui, vous pouvez profiter de l'Aide Individuelle à la Formation (AIF) d'un montant variable entre 2.000 et 4.000 euros (en fonction de votre lieu de résidence) pour financer une partie de la formation, si votre dossier est validé par votre agence. [Cliquez ici](/financements) pour accéder à toutes les solutions de financement. Cependant, France Travail aura plutôt tendance à vous orienter vers des financements Région.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: `Je suis inscrit à France Travail, puis-je bénéficier d'un financement ?`,
    answer: md.render(
      dedent`Oui, vous pouvez profiter de l'Aide Individuelle à la Formation (AIF) d'un montant variable entre 2.000 et 4.000 euros (en fonction de votre lieu de résidence) pour financer une partie de la formation, si votre dossier est validé par votre agence. Cependant, France Travail aura plutôt tendance à vous orienter vers des financements Région.`
    ),
    courses: ['RNCP5-landing', 'RNCP6-landing'],
  },
  {
    question: `J'ai des heures CPF, puis-je les utiliser ?`,
    answer: md.render(
      dedent`Oui, vous pouvez utiliser votre CPF pour financer tout ou une partie de la formation. [Cliquez ici](/financements) pour accéder à toutes les solutions de financement.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: `J'ai des heures CPF, puis-je les utiliser ?`,
    answer: md.render(
      dedent`Oui, vous pouvez utiliser votre CPF pour financer tout ou une partie de la formation.`
    ),
    courses: ['RNCP5-landing', 'RNCP6-landing'],
  },
  {
    question: `Puis-je cumuler le CPF avec d’autres dispositifs de financement ?`,
    answer: md.render(
      dedent`Oui, vous pouvez cumuler plusieurs dispositifs pour financer la formation. [Contactez-nous](/contact) pour plus de détails. [Cliquez ici](/financements) pour accéder à toutes les solutions de financement.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: `Vous parlez de CPF, mais de quoi s'agit-il exactement?`,
    answer: md.render(
      dedent`Le CPF permet à toute personne, salariée ou demandeur d’emploi, de se faire financer une formation. Pour utiliser vos heures CPF, rendez-vous sur [moncompteformation.gouv.fr](https://www.moncompteformation.gouv.fr) pour connaître la valeur de l'aide qui peut vous être attribuée.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: 'Existe-t-il une subvention pour les auto-entrepreneurs ?',
    answer: md.render(
      dedent`Oui, si vous êtes auto-entrepreneur depuis au moins un an, vous pouvez obtenir une aide de 1.400€ en formulant votre demande auprès du [FIFPL](https://www.fifpl.fr/). D'autres fonds peuvent être sollicités, comme l'AGEFICE ou La Chambre des Métiers régionale et le FAFCEA pour les artisans. [Cliquez ici](/financements) pour accéder à toutes les solutions de financement.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: 'Peut-on payer en plusieurs fois ?',
    answer: md.render(
      dedent`Oui, vous pouvez payer en 3 fois sans frais. Cependant, vous pouvez aussi passer par l'[ADIE](https://www.adie.org/) pour étaler le paiement sur 42\u00A0mensualités.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Peut-on payer en plusieurs fois ?',
    answer: md.render(
      dedent`Oui, vous pouvez payer en 4 fois sans frais. Cependant, vous pouvez aussi passer par l'[ADIE](https://www.adie.org/) pour étaler le paiement sur 42\u00A0mensualités.`
    ),
    courses: ['RNCP5'],
  },
  {
    question: 'Peut-on payer en plusieurs fois ?',
    answer: md.render(
      dedent`Oui, vous pouvez payer en 3 fois sans frais. Cependant, vous pouvez aussi passer par l'ADIE pour étaler le paiement sur 42\u00A0mensualités.`
    ),
    courses: ['RNCP6-landing'],
  },
  {
    question: 'Peut-on payer en plusieurs fois ?',
    answer: md.render(
      dedent`Oui, vous pouvez payer en 4 fois sans frais. Cependant, vous pouvez aussi passer par l'ADIE pour étaler le paiement sur 42\u00A0mensualités.`
    ),
    courses: ['RNCP5-landing'],
  },
  {
    question: `Quel est le numéro de déclaration d'activité de votre organisme ?`,
    answer: md.render(
      dedent`Nous sommes déclarés auprès de la DIRECCTE sous le numéro : 11755531275.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: 'Quel est le numéro de référencement DataDock de votre organisme ?',
    answer: md.render(dedent`Nous sommes référencés DataDock sous le numéro : 0029509.`),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: 'Votre organisme de formation est-il labellisé Qualiopi ?',
    answer: md.render(
      dedent`Oui. Nous possédons la certification qualité (Qualiopi) pour l'action de formation et pour la formation en apprentissage.`
    ),
    courses: ['RNCP5', 'RNCP6', 'RNCP5-landing', 'RNCP6-landing', 'RNCP6-landing-alternance'],
  },
  {
    question: `Je suis en poste dans une entreprise, puis-je bénéficier d'un financement ?`,
    answer: md.render(
      dedent`Si votre employeur vous laisse la possibilité de vous absenter pendant 10 semaines, le dispositif régional Transitions Pro (Ex-FONGECIF) vous permet d'être accompagné sur le financement d'un nouveau projet professionnel. Le salarié n'est pas obligé de prévenir son employeur pour faire une demande de financement. Notre formation en e-learning permet aussi d’avancer à votre rythme en parallèle de votre activité. La demande doit être soumise trois à quatre mois avant le début de la formation. Notre centre de formation est référencé dans le DataDock et est labellisé Qualiopi. [Contactez-nous](/contact) pour plus de détails.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: 'Comment faire pour suivre la formation GRATUITEMENT (ou presque) ?',
    answer: md.render(
      dedent`Notre formation est éligible aux financements Régions. [Contactez-nous](/contact) pour plus de détails.`
    ),
    courses: ['RNCP5', 'RNCP6'],
  },
  {
    question: 'Proposez-vous la formation en alternance ?',
    answer: md.render(
      dedent`Oui, vous pouvez suivre la formation sur une durée de 18 mois, en alternance. Vous signerez un CDI ou un CDD avec l'une de nos entreprises partenaires et serez rémunéré·e pendant toute la durée de votre cursus. Consultez [cette page](/formation-alternance/concepteur-developpeur-applications-full-stack-javascript/) pour plus d'informations.`
    ),
    courses: ['RNCP6'],
  },
  {
    question: `Quelles sont les modalités d'évalutation de la formation ?`,
    answer: md.render(
      dedent`Pour valider la formation, il faut obtenir une note supérieure ou égale à 50% .  
      &nbsp;  
      Le calcul de la moyenne des notes est pondéré de la manière suivante :\n &nbsp;  
      - Mises en situation professionnelle : 70%  
      - Evaluation en entreprise : 30%  
   
    `
    ),
    courses: ['full-stack'],
  },
  {
    question: `La formation est-elle accessible à tous ?`,
    answer: md.render(
      dedent`Le Reacteur s'engage pour faciliter l'accessibilité de ses formations.  
          
      Les détails de l'accueil des personnes en situation de handicap sont consultables sur la page : XXX`
    ),
    courses: ['full-stack'],
  },
  {
    question: `Quels sont les modalités et délai d'accès à la formation ?`,
    answer: md.render(
      dedent`Les candidatures sont possibles jusqu’à 15 jours ouvrés avant le début de la formation.  
      Entretien de recrutement pour mesurer l’adéquation de la formation avec le projet professionnel ainsi qu'un test de logique.  
      Taux de satisfaction 2023 : 98%   
      Taux d'insertion métier 2023 : 90%`
    ),
    courses: ['full-stack'],
  },
];

export default QA;
